<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1></h1>
        <span class="pull-right icon-right orange" @click="sendImgs()">发送</span>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page" v-if="isHideImg">

      <div class="padding-15 bg-white">
        <textarea class="font-14" width="100%" rows="5" placeholder="告诉家长孩子今天表现很好，家长开心也放心..." v-model="content" v-if="dynamicTypeId == 0"></textarea>
        <textarea class="font-14" width="100%" rows="5" placeholder="在这里写菜名，便于记录孩子的饮食情况，方便日后查看" v-model="content" v-else></textarea>
        <div class="add-pic">
          <ul class="list-group-item clearfix">
            <li v-for="(image, index) in imagesList">
              <div @click="index = index, isHideImg = false, imageSrc = image.baseAcessPath + image.thumbFilePath">
                <img :src="image.baseAcessPath + image.thumbFilePath" width="80" height="80"/>
              </div>
            </li>
            <li v-if="imagesList.length < 6">
              <div class="button-add" @click="capturePhoto();" v-if="isAndroid"></div>
              <div class="button-add" v-else>
                <form enctype="multipart/form-data" method="post" name="fileinfo">
                  <input type="file" name="pic" id="pic" accept="image/*" multiple="multiple" @change="updateImage()"/>
                </form>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="main-page" v-if="!isHideImg">
      <div class="topbar">
        <div class="clearfix main-wrap">
          <a class="pull-left img-back" @click.prevent="isHideImg = true">返回</a>
          <h1></h1>
          <span class="pull-right icon-right orange" @click="popupVisibleDeletpic = true">删除</span>
        </div>
        <div class="liner"></div>
      </div>

      <div class="bg-white" @click="isHideImg = true">
        <img class="mid-align" :src="imageSrc" width="100%" />
      </div>
    </div>

    <!-- 删除图片 -->
      <mt-popup
      v-model="popupVisibleDeletpic"
      position="bottom">
      <div class=" text-center" style="background:none">
        <ul class="list-group-item  tinny" style="margin:0">
          <li class="list-group">
            <a class="group-txt" href="javascript:;" @click="delImage(), popupVisibleDeletpic = false"><span class="orange block font-16">删除</span></a>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" @click="popupVisibleDeletpic = false" href="javascript:;"><span class="block font-16">取消</span></a>
          </li>
        </ul>
      </div>
      </mt-popup>


    <!-- <div class="maskdiv" v-if="!isHideDelImage">
      <div class="bottom-block text-center" style="background:none">
        <ul class="list-group-item  tinny">
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" v-tap="delImage()"><span class="orange block font-16">删除</span></a>
          </li>
        </ul>
        <ul class="list-group-item tinny" style="margin:0">
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" v-tap="isHideDelImage = true"><span class="block font-16">取消</span></a>
          </li>
        </ul>
      </div>
    </div> -->
  </div>

</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { service, uploadMulUrl } from '../../service'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      login_data: JSON.parse(window.localStorage['login_data']),
      curcheId: 0,
      userId: 0,
      content: '',
      dynamicTypeId: 0,
      imagesList: [],
      insert_dynamic_para: service.setPara('insertDynamic'),
      isHideImg: true,
      isHideDelImage: true,
      index: 0,
      imageSrc: '',
      fileList: [],
      popupVisibleDeletpic: false,
      isAndroid: true
    }
  },
  mounted: function () {
    this.dynamicTypeId = this.$route.params.dynamicTypeId
    this.content = ''
    this.imagesList = []
    this.fileList = []
    if (this.dynamicTypeId) {
      // var obj = document.getElementById('pic')
      // obj.value = ''
    }

    let b = window.browser()
    this.isAndroid = b.android

    this.curcheId = this.cookie_login_data.curcheId
    this.userId = this.cookie_login_data.teacherId
  },
  methods: {
    ...mapMutations([
      'addToDynamic'
    ]),
    insertDynamic: function () {
      if (this.imagesList.length == 0 && $.trim(this.content) == '') {
        Toast('内容不能为空')
        return
      }

      var tempImageList = this.imagesList.concat()

      this.insert_dynamic_para.userId = this.userId
      this.insert_dynamic_para.curcheId = this.curcheId
      this.insert_dynamic_para.content = this.content
      this.insert_dynamic_para.dynamicType = this.dynamicTypeId
      this.insert_dynamic_para.imagesList = tempImageList

      /* for (var c = 0; c < this.imagesList.length; c++) {
        tempImageList[c].baseAcessPath = ''
      } */

      Indicator.open('发布中...')
      let that = this
      let obj = {context: this, para: this.insert_dynamic_para, successFun: (response) => {
        that.insert_dynamic_para.dynamicId = response.data
        that.saveImgTolocalStorage(that.insert_dynamic_para)
        window.history.go(-1)
      }}
      service.request(obj)
    },
    updateImage: function () {
      let nl = 0
      let files = document.getElementById('pic').files
      if (files.length === 0) {
        return
      }

      if (files.length + this.imagesList.length > 6) {
        Toast('最多只能再上传' + (6 - this.imagesList.length) + '张图片')
        return
      }

      for (let i = 0; i < files.length; i++) {
        Indicator.open()
        lrz(files[i], {width: 1024})
        .then((rst) => {
          nl++
          let imageInfo = {}
          imageInfo.baseAcessPath = rst.base64
          imageInfo.srcFilePath = ''
          imageInfo.thumbFilePath = ''
          imageInfo.fileName = rst.origin.name
          this.imagesList.push(imageInfo)
          let f = {}
          f.file = rst.file
          f.name = rst.origin.name
          this.fileList.push(f)
          if (nl == files.length) {
            Indicator.close()
          }
        })
      }
    },
    delImage: function () {
      this.imagesList.splice(this.index, 1)
      this.fileList.splice(this.index, 1)
      this.isHideDelImage = true
      this.isHideImg = true
    },
    sendImgs: function () {
      let data = new window.FormData()

      for (let i = 0; i < this.fileList.length; i++) {
        data.append('pic', this.fileList[i].file, this.fileList[i].name)
      }

      let url = uploadMulUrl + this.cookie_login_data.phoneNum + '&needThumb=1'

      let that = this
      let obj = {context: this, para: data, url: url, successFun: (response) => {
        that.imagesList = []
        for (var i = 0; i < response.data.length; i++) {
          var imageInfo = {}
          imageInfo.baseAcessPath = response.data[i].image.baseAcessPath
          imageInfo.srcFilePath = response.data[i].image.srcFilePath
          imageInfo.thumbFilePath = response.data[i].image.thumbFilePath
          that.imagesList.push(imageInfo)
        }
        console.log('图片处理完成')
        that.insertDynamic()
      }}
      service.request(obj)
    },
    saveImgTolocalStorage: function (para) { // 保存图片信息到本地，便于快速读取
      var item = {}
      item.commentList = []
      item.dzList = []
      item.content = para.content
      item.dzNum = 0
      item.plNum = 0
      item.field1 = para.curcheId
      item.field2 = para.dynamicType
      item.publishDate = new Date().getTime()
      item.teacherId = para.userId
      item.teacherName = this.login_data[this.cookie_login_data.index].teacherName
      item.teacher_icon = this.login_data[this.cookie_login_data.index].teacherIcon
      item.isUploadOver = false
      item.baseAcessPath = this.cookie_login_data.baseAcessPath
      item.dynamicId = para.dynamicId
      item.isDz = false
      item.isShowTips = false
      var imgs = []
      for (var i = 0; i < this.imagesList.length; i++) {
        var img = {}
        img.baseAcessPath = this.imagesList[i].baseAcessPath
        img.imageAddress = this.imagesList[i].srcFilePath
        img.thumbAddress = this.imagesList[i].thumbFilePath
        imgs.push(img)
      }
      item.imageList = imgs
      // this.addToDynamic(item)
      this.$store.dispatch('addToDynamic', item)
      // window.localStorage['dynamic_new_' + this.dynamicTypeId] = JSON.stringify(item)
    },
    capturePhoto: function () {
      Indicator.open()
      navigator.camera.getPicture(this.onPhotoDataSuccess, this.onFail, { quality: 50, destinationType: navigator.camera.DestinationType.DATA_URL, sourceType: navigator.camera.PictureSourceType.PHOTOLIBRARY, targetWidth: 1000, targetHeight: 2000 })
    },
    onPhotoDataSuccess: function (imageData) {
      let imageInfo = {}
      imageInfo.baseAcessPath = 'data:image/jpeg;base64,' + imageData
      imageInfo.srcFilePath = ''
      imageInfo.thumbFilePath = ''
      this.imagesList.push(imageInfo)
      let f = {}
      f.file = this.dataURLtoBlob(imageInfo.baseAcessPath)
      f.name = this.fileList.length + '.png'
      this.fileList.push(f)
      Indicator.close()
    },
    onFail: function (message) {
      Indicator.close()
      // alert('Failed because: ' + message)
    },
    dataURLtoBlob: function (dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = window.atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new window.Blob([u8arr], {type: mime})
    }
  }
}
</script>
<style scoped>
  .mint-popup{background:none;}
</style>



// WEBPACK FOOTER //
// DynamicPublish.vue?2a3de1a0